<template>
	<div>
		<div
			v-if="hasContent"
			ref="ad"
			:width="adWidth"
			:height="adHeight"
			class="max-w-full mx-auto"
			:class="classOverride"
			@click="adClicked()"
			v-html="observedContent"
		/>
		<div v-else>
			<LoadingSpinner
				class="w-full h-24 text-gray-300"
			/>
		</div>
	</div>
</template>

<script>
import Bugsnag from '@bugsnag/js'
import { mapGetters } from 'vuex'

import { CONTENT_SERVER } from '@/constants'
import { AD_CLICK_EVENT } from '@/constants/gaEvents.js'

import LoadingSpinner from './LoadingSpinner.vue'

let adCount = 0

const ZONE_SIZES = {
	10: {
		width: 300,
		height: 250
	},
	11: {
		width: 730,
		height: 91
	}
}

export default {
	components: { LoadingSpinner },
	props: {
		zone: {
			type: Number,
			required: true
		},
		content: {
			type: String,
			required: true
		},
		classOverride: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			observer: false,
			isObserved: false,
			position: 0
		}
	},
	computed: {
		adWidth() {
			return ZONE_SIZES[this.zone]?.width
		},
		adHeight() {
			return ZONE_SIZES[this.zone]?.height
		},
		hasContent() {
			return this.content && this.content.length
		},
		showAd() {
			return this.isObserved && this.content
		},
		observedContent() {
			return this.showAd
				? this.content.replace(/\/pb\//g, `${CONTENT_SERVER}/pb/`)
				: ''
		},
		currentUrl() {
			return this.$route.fullPath
		},
		...mapGetters('auth', [ 'auth', 'isLoggedIn' ]),
		...mapGetters([
			'location'
		]),
		userId() {
			return this.isLoggedIn && this.auth.id
		}
	},
	mounted() {
		adCount++
		this.position = adCount
		this.$nextTick(() => {
			try {
				if ('IntersectionObserver' in window) {
					this.observer = new IntersectionObserver(this.callback)
					this.observer.observe(this.$refs.ad)
				} else {
					this.isObserved = true
				}
			} catch (e) {
				Bugsnag.notify(e)
			}
		})
	},
	// eslint-disable-next-line vue/no-deprecated-destroyed-lifecycle
	beforeDestroy() {
		adCount = 0
	},
	methods: {
		callback(entries, observer) {
			entries.forEach(entry => {
				if (entry.isIntersecting) {
					this.isObserved = true
					observer.disconnect()
				}
			})
		},
		adClicked() {
			const { ACTION, CATEGORY } = AD_CLICK_EVENT
			const eventLabel = `${this.currentUrl}|${this.userId}|${this.location?.name}|${this.position}`

			try {
				window.gtag('event', ACTION, {
					event_category: CATEGORY,
					event_label: eventLabel
				})
			} catch (e) {
				Bugsnag.notify(e)
			}
		}
	}
}
</script>

<style scoped>
.max-w-full img {
	max-width: 100%;
}
</style>
